import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { useSelector } from 'react-redux';
import { accessoriesListSelector } from '../store/accessories/selector';
import Card from './Card';
import AnimationScrollPage from '../../../../components/AnimationScrollPage';

const ListSlider = () => {
  const accessoriesList = useSelector(accessoriesListSelector);

  // Animation Scroll Page
  useEffect(() => {
    new AnimationScrollPage().init();
  }, []);

  return (
    <div className="relative animation">
      <div className="-mx-2 md:-mx-4 max-w-[280px] md:max-w-none">
        <Swiper
          className="swiper-container"
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          speed={500}
          slidesPerView={1}
          breakpoints={{
            768: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 4,
            },
          }}
          pagination={{
            clickable: true,
          }}
        >
          {accessoriesList.map((item, idx) => (
            <SwiperSlide key={idx} className="hover-box-underline px-2 md:w-1/2 md:px-4 xl:w-1/4">
              <Card
                image={item.image}
                title={item.title}
                description={item.Description}
                buyButtonLink={item.BuyLink}
                price={item.price}
                index={idx + 1}
                disclaimer={item.disclaimer}
                disclaimerInfo={item.disclaimerInfo}
                disclaimerIsBlackColor={item.disclaimerIsBlackColor}
                disclaimerOption={item.disclaimerOption}
                disclaimerIsTypeInfo={item.disclaimerIsTypeInfo}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default ListSlider;
